"use strict";

var Suite = require('../../invitation_suites/interface');

var Program = require('../../wedding_programs/interface');

var SaveTheDates = require('../../prewedding_stationery/interface');

var convertSuite = require('./invitation_suites');

var convertProgram = require('./wedding_programs');

var convertSaveTheDate = require('./save_the_dates.js');

module.exports = function (product, product_type, options) {
  var convertFn;

  if (Object.prototype.isPrototypeOf.call(Suite.prototype, product)) {
    convertFn = convertSuite(product, product_type, options);
  } else if (Object.prototype.isPrototypeOf.call(Program.prototype, product)) {
    convertFn = convertProgram(product, product_type, options);
  } else if (Object.prototype.isPrototypeOf.call(SaveTheDates.prototype, product)) {
    convertFn = convertSaveTheDate(product, product_type, options);
  }

  if (!convertFn) {
    throw new Error("No conversion function found for converting from ".concat(product.product_type, " to ").concat(product_type));
  }

  convertFn.call(product, product_type, options);
};